<template>
    <tabs value="Language">
        <tab-pane v-for="(tab, i) in activeValues" :title="labels(tab.language)" :key="tab.language">
            <slot name="body" :index="tab.index"></slot>
        </tab-pane>
    </tabs>
</template>

<script>
  import { Tabs, TabPane, Card } from 'src/components/UIComponents'

  export default {
    name: 'BasicLanguagePicker',
    components: {
      TabPane,
      Tabs,
      Card
    },
    props: {
      value: {
        type: Array
      }
    },
    computed: {
      activeValues: function() {
        // Add missing active values to the array
        for (const lang of this.$auth.user.customer.settings.contract.enabledLanguages) {
          let found = false
          for (let i = 0; i < this.value.length; ++i) {
            if (this.value[i].language === lang) {
              found = true
              break
            }
          }

          if (!found) {
            this.value.push({language: lang, text: ''})
          }
        }

        // We need to store the index before we filter out any values
        for (let i = 0; i < this.value.length; i++) {
          this.value[i].index = i
        }
        const newValue = this.value.filter(
          val => this.$auth.user.customer.settings.contract.enabledLanguages.includes(val.language)
        )

        

        return newValue
      }
    },
    methods: {
      tabs: function () {
        return this.value.map((o, i) => i)
      },
      labels: function (type) {
        switch (type) {
          case 'en':
            return this.$t('English')
          case 'de':
            return this.$t('German')
          default:
            return ''
        }
      }
    }
  }
</script>